import React from 'react';
import { useDispatch } from 'react-redux';
import { func, string } from 'prop-types';

import styles from '../../surveyParticipantsEditor.module.css';
import { removeSurveyParticipantAction } from '../../../../actions';

const RemoveParticipantButton = ({
  participantId, participantIdType, translate: t
}) => {
  const dispatch = useDispatch();
  return (
    <button
      type="button"
      onClick={() => dispatch(removeSurveyParticipantAction(participantId, participantIdType))}
      className={`${styles.button} icon--remove iconButton`}
      title={t('common.remove')}
    />
  );
};

RemoveParticipantButton.propTypes = {
  participantId: string.isRequired,
  participantIdType: string.isRequired,
  translate: func.isRequired
};

export default RemoveParticipantButton;
